import { Component } from '@theme/component';

/**
 * Megamenu — manages which L2 category is active.
 * Hover (or keyboard focus) on a [data-l2-index] swaps the active L3 list
 * and feature card, both addressed by their [data-for-l2] attribute.
 *
 * @extends Component<{}>
 */
class Megamenu extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('mouseover', this.#handleEnter);
    this.addEventListener('focusin', this.#handleEnter);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('mouseover', this.#handleEnter);
    this.removeEventListener('focusin', this.#handleEnter);
  }

  #handleEnter = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const trigger = target?.closest('[data-l2-index]');
    if (!trigger || !this.contains(trigger)) return;
    const index = trigger.getAttribute('data-l2-index');
    if (!index || index === this.dataset.activeL2) return;
    this.#setActive(index);
  };

  #setActive(index) {
    this.dataset.activeL2 = index;

    for (const item of this.querySelectorAll('[data-l2-index]')) {
      item.classList.toggle('megamenu__l2--active', item.getAttribute('data-l2-index') === index);
    }
    for (const panel of this.querySelectorAll('[data-for-l2]')) {
      panel.classList.toggle('is-active', panel.getAttribute('data-for-l2') === index);
    }
  }
}

if (!customElements.get('dev-megamenu')) customElements.define('dev-megamenu', Megamenu);
